<template>
    <div class="flex shadow-lg">
        <div
            class="flex flex-col w-full text-gray-700 bg-white border-4 rounded-sm shadow"
            :style="{ 'border-color': event.team_border_colour }"
        >
            <div class="flex justify-between m-1 border-b-4 border-red-500">
                <div class="flex items-center justify-between">
                    <img
                        :src="
                            'https://assets.website-files.com/625740b496a36ec42969c9b9/625745ec60985674d8d9a223_GB%20Row%202022_RGB.png'
                        "
                        class="w-32"
                        style="max-width: 50%"
                    />
                </div>
                <div class="flex flex-col text-lg text-lyr-blue">
                    <p class="text-sm italic">{{ event.organisation }}</p>
                    <p class="text-lg font-bold">{{ event.team_name }}</p>
                </div>
            </div>
            <div class="flex flex-col m-1 text-gray-600 border-b-2 border-lyr-blue">
                <p class="text-sm">
                    Position: <span class="text-lg text-lyr-blue">{{ event.rank }}</span>
                </p>
                <p class="text-sm">
                    Distance completed:
                    <span class="text-lg text-lyr-blue">{{ event.distance }}</span>
                </p>
            </div>
            <div class="flex justify-between h-32 p-1">
                <div class="flex flex-col justify-between">
                    <p class="text-sm text-gray-600">Fundraising for:</p>
                    <a
                        class="px-0 py-1 font-bold text-center text-red-500 border-2 border-red-500 rounded-md"
                        :href="event.donate_link"
                        target="_blank"
                        >DONATE</a
                    >
                </div>
                <a :href="event.charity_link" target="_blank"
                    ><img class="object-contain h-32" :src="event.charity_image"
                /></a>
            </div>
            <div class="flex flex-col p-1 mt-1 ">
                <a
                    class="flex overflow-visible bg-gray-400 rounded-md text-md whitespace-nowrap"
                    :href="event.social_media_link"
                    target="_blank"
                >
                    <img :src="event.social_media_image" class="w-6 h-6 rounded-md" />
                    {{ event.social_media_handle }}
                </a>
            </div>
            <div class="flex items-center justify-between p-1 pb-2">
                <a
                    class="text-sm underline text-lyr-blue"
                    :href="event.team_information_link"
                    target="_blank"
                    >Learn more about the team</a
                >
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['event'],
    name: 'TeamCard',
    data() {
        return {
            defaultImg:
                'https://assets.entrepreneur.com/content/3x2/2000/20151215195453-business-leader-group-front-leadership-team-professionals-businesspeople.jpeg',
        }
    },
    methods: {},
}
</script>
